import { useInfiniteQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetAssignedGroupsInfinite(name?: string) {
  const getAssignedGroupsInfinite = useInfiniteQuery({
    queryKey: [GroupKey.ASSIGNED_GROUPS_INFINITE, name],
    queryFn: ({ pageParam }) => GroupService.getAssignedGroups({ ...pageParam, name }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });

  const errorMessage = useErrorMessage(getAssignedGroupsInfinite.error);

  return { ...getAssignedGroupsInfinite, errorMessage };
}
